export const BRAND = {
  name: 'Azimuth Solar Design',
  shortName: 'Azimuth',
  email: 'hello@azimuthsolardesign.com',
  darkLogo: '/azimuth-logo-dark.png',
  lightLogo: '/azimuth-logo-light.png',
}
